import { fetchJSON } from '@bonnet/next/fetch';
import getConfig from 'next/config';

export default function fetchRecommendedInventory(query) {
    const { publicRuntimeConfig = {} } = getConfig();
    return fetchJSON(`${publicRuntimeConfig.personalizedListingHost}/rest/pl/v0/recommendations/listings`, { query });
}
